import { useEffect, useState, useCallback } from "react";

const KEY = "eya_basket";
const EVT = "eya-basket-change";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};
const write = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVT));
};

export const addToBasket = (course, session, learner) => {
  const items = read();
  const key = `${course.id}:${session?.id || ""}`;
  const found = items.find((i) => i.key === key);
  if (found) found.learners.push(learner);
  else items.push({
    key, course_id: course.id, title: course.title, price: Number(course.price) || 0,
    course_type: course.course_type,
    session: session ? { id: session.id, start: session.start, location: session.location } : null,
    learners: [learner],
  });
  write(items);
};

export const useBasket = () => {
  const [items, setItems] = useState(read);
  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const save = useCallback((next) => write(next.filter((i) => i.learners.length > 0)), []);
  const count = items.reduce((n, i) => n + i.learners.length, 0);
  return { items, count, save, clear: () => write([]) };
};
